<template>
  <v-card elevation="0" class="px-5">
    <v-row>
      <v-col cols="3" style="border-right:solid thin #ccc; border-top: solid thin #ccc;">
        <ProductMenu />
      </v-col>
      <v-col cols="9" style="border-top: solid thin #ccc;">
        <ProductInfo v-if="activeComponent==='ProductProfile' || activeComponent===''" />

        <v-card elevation="0">
          <component :is="activeComponent?activeComponent:'ProductProfile'" />
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import ProductMenu from './Edit/ProductMenu'
import ProductInfo from './Edit/ProductInfo'
import { mapGetters } from 'vuex'

import ProductProfile from './Edit/ProductProfile'
import ProductImage from './Edit/ProductImage'
import ProductAttribute from './Edit/ProductAttribute'
import ProductTerpene from './Edit/ProductTerpene'
import ProductAroma from './Edit/ProductAroma'
import ProductColor from './Edit/ProductColor'
import ProductFlavour from './Edit/ProductFlavour'
import ProductMood from './Edit/ProductMood'
import ProductAllergen from './Edit/ProductAllergen'
import ProductVariant from './Edit/ProductVariant'
import ProductCbd from './Edit/ProductCbd'

export default {
  components: {
    ProductMenu,
    ProductInfo,
    ProductProfile,
    ProductImage,
    ProductAttribute,
    ProductTerpene,
    ProductAroma,
    ProductColor,
    ProductFlavour,
    ProductMood,
    ProductAllergen,
    ProductVariant,
    ProductCbd
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      editModal: 'locationproduct/editPop',
      activeComponent: 'locationproduct/activeComponent'
    })
  }
}
</script>
